export enum UpdateServiceNameEnum {
  // User
  USER_INFOS = 'user-infos-update',
  USER_ALL = 'user-all',

  // Programs
  PROGRAM_ALL = 'program-all',

  // Config
  CONFIG_ALL = 'config-all',

  // Changelog
  CHANGELOG = 'changelog',

  // Token refresh
  TOKEN_REFRESH = 'token-refresh',

  // Liveness
  LIVENESS = 'liveness',
}
